import { inject, Injectable } from '@angular/core';
import {
  ChartTimeSeries,
  ExportTableDto, TimeFrame,
  TimeSeriesIdentifierInput,
  TimeSeriesPoint,
} from '@clean-code/models';
import { map, Observable } from 'rxjs';
import { ExportTableDataService } from '../infrastructure/export-table.data.service';

@Injectable({ providedIn: 'root' })
export class ExportTableFacade {
  protected service = inject(ExportTableDataService);

  public getExportTableData$(
    identifiers: TimeSeriesIdentifierInput[],
    timeFrame?: TimeFrame,
  ): Observable<Array<ExportTableDto>> {
    // timeFrame?: TimeFrame // ids: TimeSeriesIdentifierInput[],
    return this.service
      .getTimeSeriesChartData$(identifiers, timeFrame, false)
      .pipe(
        map((values: ChartTimeSeries[]) => {
          const array = new Array<ExportTableDto>();

          values.forEach((chartTimeSeries: ChartTimeSeries) => {
            chartTimeSeries.values.forEach((timeSeries: TimeSeriesPoint) => {
              array.push({
                tradeDate: timeSeries.tradeDate,
                value: timeSeries.value,
                frontOfficeName: chartTimeSeries.frontOfficeName,
                areaMarketArea: chartTimeSeries.areaMarketArea?.name,
                unit: chartTimeSeries.unit,
                deliveryDay: chartTimeSeries.deliveryDay,
                longName: chartTimeSeries.longName,
              });
            });
          });

          return array;
        }),
      );
  }
}
